export default __webpack_public_path__ + "static/media/logo.df040af8.svg";